import React, { useState, useEffect, useRef } from 'react';
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import '../shared/fonts';
import ShowError from "../shared/ShowError";
import { useSearchParams } from "react-router-dom";
import { Button } from 'primereact/button';


export default function  PrintDisiplineSheet(props){
    const [searchParams] = useSearchParams();
    const studentId = searchParams.get("studentId");
    const schoolClassId = searchParams.get("schoolClassId");
    const [loading, setLoading] = useState(true);
    const [gradeSheets, setGradeSheets] = useState([]);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [status, setStatus] = useState('idle');
    const type = 3;

  useEffect(() => {
      var params = {login:util.getTrustedUser(), schoolClassId:schoolClassId, studentId:studentId, sheetType:type};
      var url = config.Server+`/school/month/grade-sheet/get`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  console.log(response);
                  var gss = response;
                  console.log("grade sheets is> ", gss);
                  setGradeSheets(gss);
                  setLoading(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setLoading(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setLoading(false);
          });
     
  }, []);
  
    const generatePDF = async () => {
        setStatus('generating');
        
        try {
            const { jsPDF } = await import('jspdf');
            const html2canvas = (await import('html2canvas')).default;
            
            const pdf = new jsPDF('p', 'mm', 'a4');
            const students = Array.from({ length: 40 }, (_, i) => i);
            
            for (let i = 0; i < students.length; i++) {
                const element = document.getElementById(`student-${i}`);
                if (!element) continue;
                
                // ایجاد یک div موقت برای رندر بهتر
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = element.innerHTML;
                tempDiv.style.cssText = window.getComputedStyle(element).cssText;
                tempDiv.style.position = 'fixed';
                tempDiv.style.left = '0';
                tempDiv.style.top = '0';
                tempDiv.style.zIndex = '9999';
                document.body.appendChild(tempDiv);
                
                const canvas = await html2canvas(tempDiv, {
                    scale: 2,
                    useCORS: true,
                    backgroundColor: '#fff'
                });
                
                document.body.removeChild(tempDiv);
                
                if (i > 0) pdf.addPage();
                
                const imgData = canvas.toDataURL('image/png');
                const imgProps = pdf.getImageProperties(imgData);
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                
                pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            }
            
            pdf.save('کارنامه‌ها.pdf');
            setStatus('success');
            
        } catch (error) {
            console.error('خطا در تولید PDF:', error);
            setStatus('error');
        }
    };
  
  return(
    <>
      {
        loading?
        <>
        در حال دریافت کارنامه ها ...
        <br/>
        لطفا صبور باشید
        </>
        :
        errorVisible?
        <>{errorMessage}</>
        :
        <>
        <div>
            <Button onClick={generatePDF} disabled={status === 'generating'} icon="pi pi-pdf" severity="primary">
                {status === 'generating' ? 'لطفا صبر کنید...' : 'تبدیل به PDF و دانلود'}
            </Button>
            
            {status === 'success' && (
                <div className="success-message">
                    ✅ PDF با موفقیت تولید شد
                </div>
            )}
            
            {status === 'error' && (
                <div className="error-message">
                    ❌ خطا در تولید PDF
                </div>
            )}
        </div>

        {
        gradeSheets.map((gs, gsInd)=>{
          return(
            <div id={"student-"+gsInd} style={{fontFamily:"iransans", width:"calc(100% - 20px)", direction:"rtl", pageBreakAfter:"always"}}>
              <div style={{padding:"40px", borderTop:"1px solid #eee", borderRight:"1px solid #eee", borderLeft:"1px solid #eee", }}>
              <table style={{borderCollapse:"collapse", width:"100%"}}>
                <tbody>
                  <tr style={{height:"60px"}}>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #555"}}>
                      کارنامه تربیتی
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #555"}}>
                      مدرسه
                      <br/>
                      {util.toPersianDigits(util.getSchoolName())}
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #555"}}>
                      سال تحصیلی
                      <br/>
                      {util.getEducationName()}
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #555"}}>
                      کلاس
                      <br/>
                      {util.toPersianDigits(gs.schoolClass.name)}
                    </td>
                  </tr>
                  <tr style={{height:"60px"}}>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #555"}}>
                      نام و نام خانوادگی
                      <br/>
                      {gs.student.firstname + " " + gs.student.lastname}
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #555"}}>
                      نام ولی
                      <br/>
                      {gs.student.parent == null? "": (gs.student.parent.firstname + " " + gs.student.parent.lastname)}
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #555"}}>
                      رشته- پایه
                      <br/>
                      {util.toPersianDigits(gs.schoolClass.field.title + " - " + util.getDegreeChar(gs.schoolClass.degree))}
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #555"}}>
                      &nbsp;                  
                    </td>
                  </tr>
                </tbody>
              </table>

              <table style={{borderCollapse:"collapse", width:"100%", marginTop:"30px"}}>
                <tbody>
                  <tr style={{height:"40px", backgroundColor:"#555", color:"#FFF"}}>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #fff", width:"40px"}}>
                      #
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #fff", width:"110px"}}>
                      تاریخ
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #fff", width:"200px"}}>
                      نوع آیتم
                    </td>
                    <td style={{textAlign:"right", verticalAlign:"middle", border:"1px solid #fff", padding:"3px"}}>
                      شرح
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #fff", width:"75px"}}>
                      نمره مثبت
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #fff", width:"75px"}}>
                      نمره منفی
                    </td>
                  </tr>
                  {
                    gs.items.map((item, rowInd)=>{
                      return(
                  <tr style={{height:"22px", backgroundColor:(rowInd%2==0?"#fff":"#ededed")}}>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #555"}}>
                      {util.toPersianDigits(rowInd+1)}
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #555"}}>
                      {util.toPersianDigits(util.SeperateDate(item.issueDate))}
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #555"}}>
                      {item.disorderTypeTitle}
                    </td>
                    <td style={{textAlign:"right", verticalAlign:"middle", border:"1px solid #555"}}>
                      {item.comment}
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #555"}}>
                      {util.toPersianDigits(item.positiveScore)}
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #555"}}>
                      {util.toPersianDigits(item.negativeScore)}
                    </td>
                  </tr>
                      )
                    })
                  }
                  <tr style={{height:"40px"}}>
                    <td style={{padding:"5px", textAlign:"left"}} colSpan={4}>
                      جمع کل
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #fff", backgroundColor:"#555", color:"#FFF"}}>
                      {util.toPersianDigits(gs.positiveSum)}
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #fff", backgroundColor:"#555", color:"#FFF"}}>
                      {util.toPersianDigits(gs.negativeSum)}
                    </td>
                  </tr>

                </tbody>
              </table>

              <table style={{borderCollapse:"collapse", width:"100%", marginTop:"50px"}}>
                <tbody>
                  <tr style={{}}>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #fff", width:"50%"}}>
                      مدیر مدرسه
                      <br/>
                      {gs.manager.firstname + " " + gs.manager.lastname}
                    </td>
                    <td style={{textAlign:"center", verticalAlign:"middle", border:"1px solid #fff", width:"110px"}}>
                      &nbsp;
                    </td>
                  </tr>

                </tbody>
              </table>
              </div>
            </div>
          )
        })

        }
        </>
      }
    </>
  )
}
